import { apiRequest } from '../client'
import type { OverviewResponse } from '../types'

export const overviewApi = {
  getOverview: () => apiRequest<OverviewResponse>('/api/v0/admin/overview'),
}
